import type { DateTime } from 'luxon'
import { type ReactElement, useCallback, useState } from 'react'

import type { ViewpointSettings } from '@/queries/constants'

import LearnerJoinSessionModal from './internal/LearnerJoinSessionModal'
import TutorStartSessionModal from './internal/TutorStartSessionModal'
import ViewpointCollectionModal from './ViewpointCollectionModal'

export default function SessionJoinModal({
  sessionId,
  seriesId,
  sessionRegistrationId,
  viewpointSettings,
  topicName,
  open,
  isHost,
  recordingPolicyAcknowledgedAt,
  onAcknowledgeRecordingPolicy,
  onClose,
  showSATBootcampLearnerFeedback,
  pastSessionTutorSpeakingPercentage,
  hasSubmittedViewpoint,
}: {
  sessionId: number
  seriesId: number | null
  sessionRegistrationId?: number | null
  viewpointSettings?: ViewpointSettings | null
  topicName: string
  open: boolean
  isHost: boolean
  recordingPolicyAcknowledgedAt: DateTime | null
  onAcknowledgeRecordingPolicy: () => Promise<void>
  onClose: () => void
  showSATBootcampLearnerFeedback: boolean
  pastSessionTutorSpeakingPercentage: number | null
  hasSubmittedViewpoint: boolean
}): ReactElement {
  const [submittedViewpoint, setSubmittedViewpoint] = useState(hasSubmittedViewpoint)

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  if (isHost) {
    return (
      <TutorStartSessionModal
        open={open}
        onClose={handleClose}
        sessionId={sessionId}
        seriesId={seriesId}
        topicName={topicName}
      />
    )
  }

  if (viewpointSettings != null && !submittedViewpoint && sessionRegistrationId != null) {
    return (
      <ViewpointCollectionModal
        open={open}
        onClose={handleClose}
        viewpointSettings={viewpointSettings}
        sessionRegistrationId={sessionRegistrationId}
        onSubmit={() => setSubmittedViewpoint(true)}
      />
    )
  }

  return (
    <LearnerJoinSessionModal
      open={open}
      onClose={handleClose}
      sessionId={sessionId}
      seriesId={seriesId}
      topicName={topicName}
      recordingPolicyAcknowledgedAt={recordingPolicyAcknowledgedAt}
      onAcknowledgeRecordingPolicy={onAcknowledgeRecordingPolicy}
      showSATBootcampLearnerFeedback={showSATBootcampLearnerFeedback}
      pastSessionTutorSpeakingPercentage={pastSessionTutorSpeakingPercentage}
    />
  )
}
